module.exports = __webpack_public_path__ + "img/candy.8d321871.png";